import React from 'react';
import { Flex } from '@televet/kibble-ui/build/chakra';
import partial from 'lodash-es/partial';
import {
  AutomationsFieldLabel,
  AutomationsFieldContainer,
  AutomationsRadioField,
} from 'pages/Automations/components/Layout';
import { WorkflowVisitType as AutomationsVisitType } from 'shared/types/graphql';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { updateAutomationDraft } from '../../../state/automationsSlice';

export const SendFrequency = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const sendFrequency = useAppSelector((state) => state.automations.automationDraft.sendFrequency);

  const handleSendFrequencyChange = (sendFrequency: AutomationsVisitType): void => {
    dispatch(updateAutomationDraft({ sendFrequency }));
  };

  return (
    <AutomationsFieldContainer>
      <AutomationsFieldLabel>Send Frequency</AutomationsFieldLabel>
      <Flex flexDir="column" mt={2}>
        <AutomationsRadioField
          label="Per Patient Appointment"
          description="If Alex has two appointments scheduled in a single day for both of her pets, she will receive two separate
        reminders."
          value={AutomationsVisitType.Patient}
          isChecked={sendFrequency === AutomationsVisitType.Patient}
          onChange={partial(handleSendFrequencyChange, AutomationsVisitType.Patient)}
        />
        <AutomationsRadioField
          label="Per Client Visit"
          description="If Alex has two appointments scheduled in a single day for both of her pets, she will receive a single
        reminder."
          value={AutomationsVisitType.Client}
          isChecked={sendFrequency === AutomationsVisitType.Client}
          onChange={partial(handleSendFrequencyChange, AutomationsVisitType.Client)}
        />
      </Flex>
    </AutomationsFieldContainer>
  );
};
